import { Field } from "react-final-form";

import { CodeInputFieldProps } from "./types";

import CodeInput from ".";

const CodeInputField: React.FC<CodeInputFieldProps> = ({ name, ...props }) => (
  <Field
    {...{ name }}
    render={({
      input: { type: _, ...input },
      meta: { touched, modifiedSinceLastSubmit, error, submitError },
    }) => (
      <CodeInput
        error={touched && !modifiedSinceLastSubmit && (error || submitError)}
        {...input}
        {...{ ...props, name }}
      />
    )}
  />
);

export default CodeInputField;
